// frontend/src/tabs/routeSegment.js
//
// Decode a value a deep-link carried in a ROUTE SEGMENT rather than a query
// string — the only way to parameterize a tab in this shell. Tabs are keyed by
// pathname (TabsHost → findElementForPath / paramsForTabPath both matchPath the
// whole `tab.path`), so `openTab('/item-setup?brand=Nike')` resolves to no
// registered route at all. Deep links that carry a value therefore spell it as
// a segment: `/suppliers/:id/catalog/:itemCode?`, `/item-setup/item/:itemCode`.
//
// The decode is REQUIRED, not belt-and-braces: react-router's matchPath does
// not decode path params, so a segment written by encodeURIComponent arrives
// still encoded ('Alliance%20-%20Allplay'). Pinned by routeSegment.test.js
// against the installed react-router: if it ever starts decoding, that test
// fails instead of every item code silently double-decoding.

/**
 * @param {string|undefined} raw  The route param, as matchPath produced it.
 * @returns {string} The decoded value, or '' when there is no segment.
 */
export function decodeRouteSegment(raw) {
  if (!raw) return '';
  try {
    return decodeURIComponent(raw);
  } catch (error) {
    // Only reachable from a hand-edited or truncated URL — encodeURIComponent
    // never emits a malformed escape. Logged, not swallowed: the caller is
    // about to filter a grid by a value that is NOT what the URL asked for, and
    // that must be findable when someone reports "the filter shows the wrong
    // items". Returning the raw text keeps the merchant on a visibly-filtered
    // grid they can clear, where re-throwing would take the tab to the
    // ErrorBoundary and lose the whole page.
    console.error('routeSegment: undecodable route segment %o —', raw, error.message);
    return raw;
  }
}
